import "core-js/modules/es.regexp.exec.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cb216ea8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "thread-block-pc"
};
const _hoisted_2 = ["src", "onClick"];
const _hoisted_3 = ["id"];
const _hoisted_4 = {
  style: {
    "flex": "1"
  }
};
const _hoisted_5 = ["onClick", "innerHTML"];
const _hoisted_6 = {
  class: "s-icons"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = ["src"];
const _hoisted_9 = ["src"];
const _hoisted_10 = ["onClick"];
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "hr"
}, null, -1));
const _hoisted_12 = {
  class: "dateline"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "话题", -1));
const _hoisted_14 = {
  class: "replies"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico ico-message"
}, null, -1));
const _hoisted_16 = {
  class: "views"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico ico-eyes"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_checkbox = _resolveComponent("van-checkbox");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_CreditsIcon = _resolveComponent("CreditsIcon");
  const _component_van_row = _resolveComponent("van-row");
  const _component_image_cdn = _resolveComponent("image-cdn");
  const _component_router_link = _resolveComponent("router-link");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.threads, item => {
    return _openBlock(), _createBlock(_component_van_row, {
      key: 'thread-' + item.tid,
      id: 'thread-' + item.tid,
      class: "thread-card"
    }, {
      default: _withCtx(() => [_createElementVNode("img", {
        class: "avatar",
        src: _ctx.$filters.promoteUrl('/' + item.avatar + '&version=' + $setup.versionControl),
        width: "52px",
        height: "52px",
        onClick: $event => $setup.gotoUserPage(item.authorid, true)
      }, null, 8, _hoisted_2), $setup.state.showChkbox ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "admin-chkbox",
        id: 'admintoolchkbox-' + item.tid
      }, [_createVNode(_component_van_cell, {
        clickable: "",
        onClick: $event => $setup.toggle(item.tid),
        style: {
          "padding": "24px 16px"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_van_checkbox, {
          shape: "square",
          "icon-size": "14px",
          name: item.tid,
          ref_for: true,
          ref: el => $setup.checkboxRefs[item.tid] = el,
          onClick: [$event => $setup.toggle(item.tid), _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))]
        }, null, 8, ["name", "onClick"])]),
        _: 2
      }, 1032, ["onClick"])], 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_van_row, {
        align: "center",
        class: "first-line"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "subject",
          onClick: $event => $setup.gotoPage(item.post_url, true),
          innerHTML: _ctx.$filters.highlight(item.subject, $props.highlightKeyword)
        }, null, 8, _hoisted_5), _createElementVNode("div", _hoisted_6, [item.displayorder > 0 && !$props.disableOrderTop ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          class: "s-icon",
          src: require('@/assets/images/pc/icons/post-status-zhiDing.png'),
          alt: ""
        }, null, 8, _hoisted_7)) : _createCommentVNode("", true), item.donate_count > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 1,
          class: "s-icon",
          src: require('@/assets/images/pc/icons/post-status-daShang.png'),
          alt: ""
        }, null, 8, _hoisted_8)) : _createCommentVNode("", true), item.digest > 0 ? (_openBlock(), _createElementBlock("img", {
          key: 2,
          class: "s-icon",
          src: require('@/assets/images/pc/icons/post-status-jingHua-' + item.digest + '.png'),
          alt: ""
        }, null, 8, _hoisted_9)) : _createCommentVNode("", true), item.replycredit > 0 ? (_openBlock(), _createBlock(_component_CreditsIcon, {
          key: 3,
          isPlayAnimation: $setup.test
        }, null, 8, ["isPlayAnimation"])) : _createCommentVNode("", true)])]),
        _: 2
      }, 1024), _createVNode(_component_van_row, {
        align: "center",
        class: "second-line"
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", {
          class: "author",
          onClick: $event => $setup.gotoUserPage(item.authorid)
        }, _toDisplayString(item.author), 9, _hoisted_10), _createVNode(_component_image_cdn, {
          class: _normalizeClass(["medals", {
            master: $setup.medalsNum(item.medals) === 59
          }]),
          src: require('@/assets/images/icons/mb-v' + $setup.medalsNum(item.medals) + '.png'),
          alt: ""
        }, null, 8, ["class", "src"]), _hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$filters.dateDurationFormat(item.dateline)), 1)]), _createElementVNode("div", null, [$setup.showTopicBlock(item.topic_list.length) ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["topic", {
            'topic-admin': $setup.state.showChkbox
          }])
        }, [_hoisted_13, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.topic_list, (topic, index) => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: index
          }, [+_ctx.$route.params.id !== +topic.topic_id ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: {
              name: 'topic',
              params: {
                id: topic.topic_id,
                query: ['hot']
              }
            }
          }, {
            default: _withCtx(() => [_createTextVNode(" #" + _toDisplayString(topic.topic_name) + "# ", 1)]),
            _: 2
          }, 1032, ["to"])) : _createCommentVNode("", true)], 64);
        }), 128))], 2)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_14, [_hoisted_15, _createElementVNode("span", null, _toDisplayString(_ctx.$filters.priceFormatInt(item.total_replies)), 1)]), _createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(_ctx.$filters.priceFormatInt(item.views)), 1)])])]),
        _: 2
      }, 1024)])]),
      _: 2
    }, 1032, ["id"]);
  }), 128))]);
}